import { useParams } from 'react-router-dom';

import { useCommit, useRepo, useSelectedTenant } from '@/hooks/useSwr';
import { appHubIndexPath, appPromptsIndexPath } from '@/utils/constants';

import { validateManifest } from '../../Playground/manifest-validation';
import { getPromptManifest } from '../../Playground/utils/Playground.utils';

export const useRepoData = (inHub: boolean) => {
  const { owner, repo, commit } = useParams();
  const {
    data: repoObj,
    isLoading: repoLoading,
    error: repoError,
  } = useRepo(owner, repo!);

  const hasCommits = !!repoObj?.repo?.num_commits;
  const currentCommit = commit || repoObj?.repo?.last_commit_hash;

  const {
    data: commitObj,
    isLoading: commitLoading,
    error: commitError,
  } = useCommit({
    owner,
    repo: repo!,
    sha: currentCommit,
    get_examples: true,
  });

  const { data: selectedTenant, isLoading: tenantLoading } =
    useSelectedTenant();

  const promptManifest = commitObj?.manifest
    ? getPromptManifest(commitObj?.manifest)
    : commitObj?.manifest;
  const playgroundLinkBase = `/${
    inHub ? `${appHubIndexPath}/${owner}` : appPromptsIndexPath
  }/${repo}/playground`;
  const playgroundParams = selectedTenant
    ? { organizationId: selectedTenant.id, commit }
    : { commit };
  const playgroundError = promptManifest
    ? validateManifest(promptManifest)
    : null;

  return {
    owner: owner as string,
    repo: repo as string,
    commit,
    repoObj,
    commitObj,
    hasCommits,
    loading: repoLoading || commitLoading || tenantLoading,
    error: repoError || commitError,
    selectedTenant,
    playgroundLinkBase,
    playgroundParams,
    playgroundError,
  };
};
